import AddrLine1 from './AddrLine1';
import AddrLine2 from './AddrLine2';
import City from './City';
import Division from './Division';
import PostCode from './PostCode';
import Country from './Country';

const index = {
    AddrLine1,
    AddrLine2,
    City,
    Division,
    PostCode,
    Country,
};

export default index;